// extracted by mini-css-extract-plugin
module.exports = {"item":"_7a3fb80146--item--lMvlJ","row":"_7a3fb80146--row--qt1Ko","title":"_7a3fb80146--title--Sw2Mg","value":"_7a3fb80146--value--b1PYB"};